// Firebase v11 Modular Configuration
import { initializeApp, getApps, getApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  onSnapshot,
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  increment,
  where,
  query,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  setDoc,
  arrayRemove,
  arrayUnion,
  writeBatch,
  serverTimestamp,
  runTransaction,
} from "firebase/firestore";
import {
  getAuth,
  onAuthStateChanged,
  signInWithCustomToken,
  signOut,
} from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
// Firebase messaging will be dynamically imported only when supported

const firebaseConfig = {
  apiKey: "AIzaSyBvy9wwbHmVfNXy_XiaengbrcC0AeSHWp0",
  authDomain: "its-connect-main.firebaseapp.com",
  databaseURL: "https://its-connect-main-default-rtdb.firebaseio.com",
  projectId: "its-connect-main",
  storageBucket: "its-connect-main.appspot.com",
  messagingSenderId: "1001127722110",
  appId: "1:1001127722110:web:7db56f4369dbc7a8a96c2f",
  measurementId: "G-KB3ZEJVTPK"
};

// Initialize Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);


// Initialize Firestore with persistent local cache
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    synchronizeTabs: true,
  }),
});

// Initialize other services
const auth = getAuth(app);
const functions = getFunctions(app);
const storage = getStorage(app);

// Initialize messaging only if browser supports it
let messaging = null;

function isPushNotificationSupported() {
  // Check for basic requirements
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    return false;
  }
  
  // Additional check for Notification API
  if (!("Notification" in window)) {
    return false;
  }
  
  // Check if we're in a secure context (required for service workers)
  if (!window.isSecureContext) {
    return false;
  }
  
  return true;
}

// Initialize messaging asynchronously using dynamic import
async function initializeMessaging() {
  if (!isPushNotificationSupported()) {
    console.log("Push notifications not supported in this browser");
    return null;
  }

  try {
    // Dynamic import only loads Firebase messaging when supported
    const { getMessaging, isSupported } = await import("firebase/messaging");

    // Firebase's own support check (more comprehensive)
    const messagingSupported = await isSupported();
    if (!messagingSupported) {
      console.log("Firebase messaging not supported in this browser");
      return null;
    }

    messaging = getMessaging(app);
    console.log("Firebase messaging initialized successfully");
    return messaging;
  } catch (error) {
    console.log("Could not initialize Firebase messaging:", error.message);
    return null;
  }
}

// Initialize messaging when the module loads
initializeMessaging();

// Helper function to get messaging instance safely
export const getMessagingInstance = () => messaging;

// Export configured instances
export { app, db, auth, functions, storage, messaging, isPushNotificationSupported };

// Export Firestore functions
export {
  onSnapshot,
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  increment,
  where,
  query,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  setDoc,
  arrayRemove,
  arrayUnion,
  writeBatch,
  serverTimestamp,
  runTransaction,
};

// Export Auth functions
export { onAuthStateChanged, signInWithCustomToken, signOut };

// Export Functions
export { httpsCallable };

// Export Storage functions
export { ref, uploadBytes, getDownloadURL };

export default app;
